<template>
  <b-container v-if="createAny('users')" fluid>

    <!-- Title bar -->
    <div class="title-bar">
      <h1>{{ $t("titles.reviews") }}</h1>
      <div @click="edit_review({ id: 0 })" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.addreview") }}
      </div>
    </div>
    <!-- Table -->
    <b-table :items=reviewrequests :fields=fieldsrequests @row-clicked="onreviewClick">
      <template #cell(actions)="row">
        <div class="action-items">
          <a href="javascript:;" class="btn" @click="deleteReview(row.item.id)" :title="$t('labels.deletereview')">
            <font-awesome-icon icon="trash" /> {{$t('labels.deletereview')}}
          </a>
        </div>
      </template>
      <template #cell(questions)="row">
        {{ JSON.parse(row.item.questions).length }}
      </template>
      </b-table>
    <hr>

    <div class="title-bar">
      <h1>{{ $t("titles.reviewquestions") }}</h1>
      <div @click="edit_question({ id: 0 })" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.adquestion") }}
      </div>
    </div>

    <!-- Table -->
    <b-table :items=reviewquestions :fields=fieldsquestions @row-clicked="onquestionClick">
      <template #cell(actions)="row">
        <div class="action-items">
          <a href="javascript:;" class="btn" @click="deleteQuestion(row.item.id)" :title="$t('labels.deletequestion')">
            <font-awesome-icon icon="trash" /> {{$t('labels.deletequestion')}}
          </a>
        </div>
      </template>
      <template #cell(question_type)="row">
        <span v-if="row.item.question_type==1">{{ $t("labels.questiontype1") }}</span>
        <span v-if="row.item.question_type==2">{{ $t("labels.questiontype2") }}</span>
        <span v-if="row.item.question_type==3">{{ $t("labels.questiontype3") }}</span>
      </template>
    </b-table>
  <BSReviewQuestionModal :question_id="question_id"  @refresh="refreshQuestions()"/>
  <BSReviewModal :review_id="review_id" @refresh="refreshReviewRequests()"/>
  </b-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import BSReviewQuestionModal from './modals/BSReviewQuestionModal'
import BSReviewModal from './modals/BSReviewModal'
import popup_modal from './modals/PopupModal.vue'
import axios from 'axios'

export default {
  name: 'codesscreen',
  data() {
    return {
      question_id:0,
      review_id:0,
      selectedID: null,
      reviewquestions:[],
      reviewrequests:[]
    }
  },
  mounted(){
    this.refreshQuestions();
    this.refreshReviewRequests();
  },
  computed: {
    fieldsquestions() {
      return [
      { key: 'question', label: this.$i18n.t('labels.question') ,  sortable: true, sortDirection: 'desc' },
      { key: 'question_type', label: this.$i18n.t('labels.questiontype') ,  sortable: true, sortDirection: 'desc' },
      { key: 'actions', label: this.$i18n.t('labels.actions') },
      ]
    },
    fieldsrequests() {
      return [
      { key: 'description', label: this.$i18n.t('labels.title') ,  sortable: true, sortDirection: 'desc' },
      { key: 'questions', label: this.$i18n.t('labels.question') +" #" ,  sortable: true, sortDirection: 'desc' },
      { key: 'actions', label: this.$i18n.t('labels.actions') },
      ]
    },    

    ...mapState([
      'biccodes',
    ]),
    ...mapGetters([
      'biccode_by_id',
      'confirm_modal',
      'createAny'

    ]),
  },
  methods: {
    ...mapActions([
      'delete_biccode',
      'save_biccode'
    ]),
    refreshQuestions(){
      axios.get("/api/reviewquestions/all")
        .then((response) => {
          this.reviewquestions =  response.data
        })
        .catch(() => {
        });
    },
    refreshReviewRequests(){
      axios.get("/api/reviewrequest/all")
        .then((response) => {
          this.reviewrequests =  response.data
        })
        .catch(() => {
        });

    },
    deleteQuestion(id) {
      this.selectedID = id
      let message = this.$i18n.t('labels.confirmdeletehead') + this.reviewquestions.filter(rq=>rq.id==id)[0].question + this.$i18n.t('labels.confirmdeletetail')
      this.$modal.hide('popup_modal')
      this.$modal.show(popup_modal, {
        message: message,
      }, {
        name: 'popup_modal',
        draggable: false,
        height: 'auto',
        width: '500px'
      }, {
        'before-close': this.modalClose
      })

      this.$emit('close')

    },
    modalClose() {
      if (this.confirm_modal.id == 1) {
        axios.delete("/api/reviewquestion/" + this.selectedID)
        this.refreshQuestions()

      }
    },
    deleteReview(id) {
      this.selectedID = id
      let message = this.$i18n.t('labels.confirmdeletehead') + this.reviewrequests.filter(rq=>rq.id==id)[0].description + this.$i18n.t('labels.confirmdeletetail')
      this.$modal.hide('popup_modal')
      this.$modal.show(popup_modal, {
        message: message,
      }, {
        name: 'popup_modal',
        draggable: false,
        height: 'auto',
        width: '500px'
      }, {
        'before-close': this.modalCloserequest
      })

      this.$emit('close')

    },
    modalCloserequest() {
      console.log('modalCloserequest', this.confirm_modal.id, this.selectedID)
      if (this.confirm_modal.id == 1) {
        axios.delete("/api/reviewrequest/" + this.selectedID)
        this.refreshReviewRequests()

      }
    },
    onquestionClick(row) {
      this.question_id = row.id
      console.log("ËDITQUESTION", row.id)
      this.$bvModal.show('BSReviewQuestionModalID')
    },
    edit_question(code) {
      this.question_id = code.id
      this.$bvModal.show('BSReviewQuestionModalID')
    },
    onreviewClick(row) {
      this.review_id = row.id
      this.$bvModal.show('BSReviewModalID')
    },
    edit_review(code) {
      this.review_id = code.id
      this.$bvModal.show('BSReviewModalID')
    },

  },
  components:{BSReviewQuestionModal,BSReviewModal}
}
</script>